import {get} from './base.service'
export default{
    /* 获取微信公众号签名等配置文件 */
    getWechatConfig(params) {
        return get('/app/wechat/jsapisign', {
            params: params
        })
    },
}


// WEBPACK FOOTER //
// ./src/service/wechat.service.js